import { useVersionCheck } from "../../hooks/useVersionCheck.jsx";
import { activeBrand } from "../brands/index.js";

/**
 * Reusable component that generates the footer version text.
 * Product name and company name come from the active skin (theme/brands).
 *
 * @param {object} props
 * @param {string} props.separator - Text to separate parts (default: " | ")
 */
export default function VersionText({ separator = " | " }) {
  const appVersion = useVersionCheck();
  const { productName, companyName } = activeBrand.footer ?? {};

  const versionText = `${productName}${separator}Version ${appVersion}${separator}${companyName}`;

  return versionText;
}
